import { createDetailReducer } from '../../../common/services/reducerCreator';

export default createDetailReducer({
  modelName: 'CLASSEMENT',
  of: {
    tournament: { get: 'classement' },
  },
});
